import styled from "styled-components";

export const MinuteInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 150px;
  padding-bottom: 100px;
  gap: 27px;
`;

export const TitleContainer = styled.div`
  padding-left: 16px;
  align-items: baseline;
`;

export const SubTitleContainer = styled.div`
  align-items: baseline;
  justify-content: space-between;
  display: flex;
  margin-top: 30px;
  margin-bottom: 1rem;
`;

export const ApproverContainer = styled.div`
  padding-right: 50px;
  padding-left: 8px;
  margin-bottom: 10px;
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(261px, 1fr));
`